import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import { fetchGetClientsWorkingPoints } from "../../../../redux/api/general.api";
import CustomButton from "../../../../components/CustomButton";
import {
  clearScheduleWorkingPoints,
  setClientSelectedUndeliveredAwb,
} from "../../../../redux/reducer/expedition.reducer";
import { ClientsWorkingPointsDataInterface } from "../../../../redux/interfaces/general.interface";
import {
  fetchChangeWorkingPoint,
  fetchUndeliveredAwb,
} from "../../../../redux/api/expedition.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalList, {
  ModalListItem,
} from "../../../../components/misc/ModalList/ModalList";

function ChangeWorkingPointModal() {
  const dispatch = useAppDispatch();

  const {
    general: {
      clientsWorkingPoints: {
        data: { data: workingPoints },
      },
    },
    expedition: { clientSelectedUndeliveredAwb },
    user: {
      data: { id_client },
    },
  } = useAppSelector((state) => ({
    general: state.general,
    expedition: state.expedition,
    user: state.user,
  }));

  const [selectedWorkingPoint, setSelectedWorkingPoint] =
    useState<ClientsWorkingPointsDataInterface | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearScheduleWorkingPoints());
      setSelectedWorkingPoint(null);
    };
  }, [dispatch]);

  const initialClientsRoutesList: ModalListItem[] = useMemo(
    () =>
      workingPoints.map((item) => {
        const { id_punctlucru: id, denumire: label } = item;
        return {
          ...item,
          label: `${label}`, // required
          id: id, // required
          backgroundColor:
            id === selectedWorkingPoint?.id_punctlucru ? "warning" : "info",
        };
      }),
    [workingPoints, selectedWorkingPoint],
  );

  const workingPointsModalActions = useCallback(
    ({ search }: { search: string }) => {
      if (clientSelectedUndeliveredAwb?.id_doctrans) {
        dispatch(
          fetchGetClientsWorkingPoints({
            page: 1,
            perPage: 50,
            searchPctLucru: search,
          }),
        );
      }
    },
    [dispatch, clientSelectedUndeliveredAwb?.id_doctrans],
  );

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!clientSelectedUndeliveredAwb || !selectedWorkingPoint) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        fetchChangeWorkingPoint({
          id_doctrans: clientSelectedUndeliveredAwb?.id_doctrans,
          idPctLucru: selectedWorkingPoint.id_punctlucru,
          id_client: id_client,
        }),
      );

      if (
        checkEndpointStatus(resultAction, fetchChangeWorkingPoint) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, fetchChangeWorkingPoint) ===
        endpointStatus.fulfilled
      ) {
        dispatch(
          fetchUndeliveredAwb({
            page: 1,
            perPage: 50,
            pctlivrare: "",
            nodDestinatie: "",
            doc_trans: "",
            status: "all",
          }),
        );

        setSelectedWorkingPoint(null);
        handleClose && handleClose();
      }
    },

    [clientSelectedUndeliveredAwb, dispatch, id_client, selectedWorkingPoint],
  );

  const onClose = useCallback(() => {
    dispatch(setClientSelectedUndeliveredAwb(null));
    setSelectedWorkingPoint(null);
  }, [dispatch]);

  return (
    <ModalList
      dynamicModalOpen={!!clientSelectedUndeliveredAwb}
      onClose={onClose}
      label="Schimbare punct lucru"
      modalTitle={"Schimbare punct lucru"}
      searchPlaceholder={"Cauta punct lucru"}
      items={initialClientsRoutesList}
      modalActions={workingPointsModalActions}
      selectedItem={{
        id: selectedWorkingPoint?.id_punctlucru || "",
        label: selectedWorkingPoint?.denumire || "",
      }}
      setSelectedItem={setSelectedWorkingPoint}
      withCloseAfterSelect={false}
      CustomModalFooter={({ handleClose }: any) => (
        <div className="d-flex justify-content-between">
          <CustomButton onClick={handleClose}>Inapoi</CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            onClick={() => {
              handleOnSubmit({ handleClose });
            }}>
            Salveaza
          </CustomButton>
        </div>
      )}
      CustomOpenModalComponent={() => <></>}
    />
  );
}

export default ChangeWorkingPointModal;
